import React, {useContext, useState} from 'react';

import {
    Autocomplete,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from '@mui/material';

import {ComuneContext} from '../ComuneContext';

export const ImportDialog = ({open, handleClose, handleSubmit, ...props}) => {

    const {
        state,
        setState,

        isLoadingComuni,
        getComuniAsync,
    } = useContext(ComuneContext)

    const {
        comuniOptions,
    } = state;

    const [importComuneId, setImportComuneId] = useState(null);

    return (
        <>
            <Dialog open={open} onClose={handleClose} fullWidth>
                <DialogTitle>Importa le competenze</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Scegli il comune da cui importare
                    </DialogContentText>
                    <Autocomplete
                        onInputChange={(e, value) => {
                            getComuniAsync(value?.split(" (")[0])
                        }}
                        component={Autocomplete}
                        options={comuniOptions}
                        onChange={(e, value) => {
                            setImportComuneId(value?.comuneId);
                        }}
                        value={comuniOptions.find(option => option.comuneId == importComuneId) ?? ""}
                        renderInput={(params) => <TextField {...params} label="Scegli..."/>}
                        fullWidth
                        sx={{marginTop: 2}}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Annulla</Button>
                    <Button onClick={() => handleSubmit(importComuneId)}>Importa</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}